module.exports = __webpack_public_path__ + "static/fizban-argues-with-statue-77e2b948eded59c1d5d92f32ffedc119.jpg";